import { format, unwrapFunctionStore } from 'svelte-i18n';

const $format = unwrapFunctionStore(format);

export const previewingChanges = {
  element: '#signature-editor > div.page-content > div > div.editor-left-pane > div:nth-child(2)',
  popover: {
    title: $format('label.TOURS.STUDIO.EDIT.PREVIEW.CHANGES.TITLE'),
    description: $format('label.TOURS.STUDIO.EDIT.PREVIEW.CHANGES.DESCRIPTION')
  }
};

export const previewSettings = {
  element: '.signature-preview-settings',
  popover: {
    description: $format('label.TOURS.STUDIO.EDIT.PREVIEW.SETTINGS.DESCRIPTION')
  }
};
